import React, { Reducer } from 'react';
import {
  initialShippingState,
  OVERSEAS_SHIPPING_FORM_ACTION,
  overseasShippingFormReducer,
  OVERSEAS_SHIPPING_FORM_STATE,
} from './reducer';
import { OverseasShippingFormContext } from './context';
import { persistState } from '../../utils/persist-state';

const OverseasShippingFormProvider: React.FC = ({ children }) => {
  const [formState, dispatchUpdateForm] = React.useReducer<
    Reducer<OVERSEAS_SHIPPING_FORM_STATE, OVERSEAS_SHIPPING_FORM_ACTION>
  >(overseasShippingFormReducer, initialShippingState);

  React.useEffect(() => persistState('overseas-shipping', formState), [
    formState,
  ]);

  return (
    <OverseasShippingFormContext.Provider
      value={{ formState, dispatch: dispatchUpdateForm }}
    >
      {children}
    </OverseasShippingFormContext.Provider>
  );
};

export default OverseasShippingFormProvider;
